import { inject, Injectable } from '@angular/core';

import { LoadingController, LoadingOptions, ModalController } from '@ionic/angular/standalone';

import { LoadingScreenComponent } from '../../components/loading-screen/loading-screen.component';

type LoadingServiceModalOptions = {
    title?: string;
    text?: string;
};

@Injectable({
    providedIn: 'root'
})
export class LoadingService {
    loadingController = inject(LoadingController);
    modalController = inject(ModalController);

    // public loader;
    isLoading: boolean = false;
    defaultDuration: number = 20000;

    modal?: HTMLIonModalElement;

    async presentLoading(options?: LoadingOptions) {
        this.isLoading = true;
        const loadOptions = options || {};
        return await this.loadingController
            .create({
                duration: this.defaultDuration,
                ...loadOptions
            })
            .then(a => {
                a.present().then(() => {
                    if (!this.isLoading) {
                        a.dismiss().then();
                    }
                });
            });
    }

    async dismissLoading() {
        this.isLoading = false;
        return await this.loadingController.dismiss();
    }

    async presentLoadingScreen(options?: LoadingServiceModalOptions): Promise<void> {
        this.modal = await this.modalController.create({
            component: LoadingScreenComponent,
            componentProps: {
                title: options?.title,
                text: options?.text
            },
            cssClass: 'modal-full-screen'
        });

        await this.modal.present();
    }

    async dismissLoadingScreen(): Promise<void> {
        if (!this.modal) return;

        await this.modal.dismiss();
    }
}
